module.exports = __webpack_public_path__ + "img/tursab.693f6713.png";